/**
 * Whether the API is answering "service unavailable" (HTTP 503: Laravel's
 * maintenance mode, a deploy, an overloaded host). A tiny external store so
 * the axios interceptor can set it and `ServiceStatusNotice` can show it.
 * Any successful response clears it.
 */
export type ApiStatus = 'ok' | 'unavailable';

let status: ApiStatus = 'ok';
const listeners = new Set<() => void>();

function set(next: ApiStatus): void {
  if (status === next) return;
  status = next;
  listeners.forEach(listener => listener());
}

export function getApiStatus(): ApiStatus {
  return status;
}

export function reportApiUnavailable(): void {
  set('unavailable');
}

export function reportApiOk(): void {
  set('ok');
}

export function subscribeApiStatus(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
